import { SearchCondition } from 'commons/constants/KeyFlowConstants';
import { AscType, SortType } from 'commons/constants/type';
import KeyFlowParamVO from 'commons/vo/param/KeyFlowParamVO';
import { extend } from 'lodash';

export type ScriptPutParamVOProps = {
  ID: number;
  IN_POINT: number;
  OUT_POINT: number;
};

export type ScriptParamVOProps = {
  videoId?: number;
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType[];
  keyword?: string;
  inPoint?: number;
  outPoint?: number;
};

class ScriptParamVO extends KeyFlowParamVO {
  videoId?: number;
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType[];
  keyword?: string;
  inPoint?: number;
  outPoint?: number;

  constructor(data: ScriptParamVOProps) {
    super();
    this.videoId = data.videoId;
    this.retr = data.retr || 10;
    this.page = data.page || 0;
    this.sort = data.sort || [SearchCondition.Sort.DATE_OF_GAME];
    this.asc = data.asc || SearchCondition.Asc.DESC;
    this.keyword = data.keyword;
    this.inPoint = data.inPoint;
    this.outPoint = data.outPoint;
  }
}

export default ScriptParamVO;
